import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import './config/firebase';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import AppRoutes from './routes/AppRoutes';

function AppContent() {
  return <AppRoutes />;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <NotificationProvider>
          <AppContent />
        </NotificationProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
